import type { Workspace } from '../workspaces.type'

/**
 * Resolves lastUsedProjectId for a workspace id from current or listed workspaces.
 */
export function getLastUsedProjectIdForWorkspace(
  workspaces: Workspace[],
  currentWorkspace: Workspace | null,
  workspaceId: string
): string | null {
  if (currentWorkspace?.workspaceId === workspaceId) {
    return currentWorkspace.lastUsedProjectId ?? null
  }

  return workspaces.find((workspace) => workspace.workspaceId === workspaceId)?.lastUsedProjectId ?? null
}
